import { ReactNode } from "react";
import { boolean } from "yup";
import { View } from "./View";

interface IOverflowMenuDropDownItemProps {
  // children?: ReactNode;

  index: number;
  itemText?: string;
  href?: string;

  title?: string;
  className?: string;
  wrapperClassName?: string;

  hasDivider?: boolean;
  disabled?: boolean;
  isDelete?: boolean;
  requireTitle?: boolean;

  onClick?: (e: any) => void;
  onClose?: (e: any) => void;
  onOpen?: (e: any) => void;

  closeMenu?: () => boolean;
}

export const OverflowMenuDropDownItem = (
  props: IOverflowMenuDropDownItemProps
) => {
  return <View {...props} />;
};
